<template>
  <BaseSlugPage :filters="filters" />
</template>

<script setup>
import BaseSlugPage from "~/nuxt_modules/blog/ui/components/BaseSlugPage.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";

definePageMeta({
  key: "postsByTag",
});

const route = useRoute();
const { isTagExist, getTag } = useBlogStore();

if (!isTagExist(route.params.tagSlug)) {
  throw showError({
    statusCode: 404,
    statusMessage: "Such blog tag doesn't exist",
  });
}

useSeoMeta({
  title: () => getTag(route.params.tagSlug).metaTitle,
  description: () => getTag(route.params.tagSlug).metaDescription,
});

const filters = computed(() => {
  return {
    tags: {
      slug: route.params.tagSlug,
    },
  };
});
</script>

<style scoped lang="scss"></style>
